(function () {
  var timer = null;
  var lastAt = 0;

  function formatMoney(cents, format) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && format) {
      try {
        return Shopify.formatMoney(cents, format);
      } catch (e) {}
    }
    var value = (cents / 100).toFixed(2);
    if (!format) return '$' + value;
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, value);
  }

  function updateBars(cart) {
    var bars = document.querySelectorAll('[data-pj-free-shipping]');
    if (!bars.length) return;

    var total = cart && typeof cart.items_subtotal_price === 'number'
      ? cart.items_subtotal_price
      : (cart && typeof cart.total_price === 'number' ? cart.total_price : 0);
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 11000;
      var progressTpl = bar.getAttribute('data-progress-template') || 'Spend {{ amount }} more for free shipping';
      var unlockedTpl = bar.getAttribute('data-unlocked-template') || "You've unlocked free shipping!";
      var moneyFormat = bar.getAttribute('data-money-format') || '${{amount}}';
      var msgEl = bar.querySelector('[data-pj-fs-msg]');
      var fillEl = bar.querySelector('[data-pj-fs-fill]');

      if (itemCount <= 0 && total <= 0) {
        bar.setAttribute('hidden', '');
        return;
      }
      bar.removeAttribute('hidden');

      var remaining = Math.max(0, threshold - total);
      var progress = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;

      if (msgEl) {
        msgEl.textContent = remaining <= 0
          ? unlockedTpl
          : progressTpl.replace(/\{\{\s*amount\s*\}\}/g, formatMoney(remaining, moneyFormat));
      }
      if (fillEl) fillEl.style.width = progress + '%';
      bar.classList.toggle('is-unlocked', remaining <= 0);
    });
  }

  function fetchCart() {
    var now = Date.now();
    if (now - lastAt < 250) {
      clearTimeout(timer);
      timer = setTimeout(fetchCart, 260);
      return;
    }
    lastAt = now;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateBars)
      .catch(function () {});
  }

  function scheduleFetch() {
    clearTimeout(timer);
    timer = setTimeout(fetchCart, 120);
  }

  function patchFetch() {
    if (!window.fetch || window.__pjFreeShipFetchPatched) return;
    window.__pjFreeShipFetchPatched = true;
    var original = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = String(args[0] && args[0].url ? args[0].url : args[0] || '');
      return original.apply(this, args).then(function (response) {
        if (/\/cart\/(add|change|update|clear)/.test(url)) scheduleFetch();
        return response;
      });
    };
  }

  function init() {
    patchFetch();
    fetchCart();
    document.addEventListener('cart:updated', scheduleFetch);
    document.addEventListener('pj:cart:updated', scheduleFetch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
